import {Component as $c0oXD$Component, createContext as $c0oXD$createContext, useRef as $c0oXD$useRef, useContext as $c0oXD$useContext, createElement as $c0oXD$createElement} from "react";
import $c0oXD$macrostrathyper from "@macrostrat/hyper";
import {path as $c0oXD$path} from "d3-path";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;



var $e658232a3eec400d$exports = {};

$e658232a3eec400d$exports = (parcelRequire("daZiC")).getBundleURL('c0oXD') + "context.4f0f40f1.js";


var $f05a6d04e7441f4a$exports = {};

$f05a6d04e7441f4a$exports = (parcelRequire("daZiC")).getBundleURL('c0oXD') + "frame.module.450fac4c.css";


const $fe5bf96defe66407$var$h = (0, $c0oXD$macrostrathyper).styled((0, (/*@__PURE__*/$parcel$interopDefault($f05a6d04e7441f4a$exports))));
let $fe5bf96defe66407$var$sequence = 0; // Initialize a sequence counter
function $fe5bf96defe66407$var$getUniqueIdentifier() {
    // Generate a unique identifier using a sequential method that is stable across repeated
    // re-renders. This evolves from a UUID-based approach for SSR (server-side rendering) compatibility.
    const id = `uuid-${$fe5bf96defe66407$var$sequence}`;
    $fe5bf96defe66407$var$sequence += 1; // Increment the sequence for the next call
    return id;
}
class $fe5bf96defe66407$export$748c8bb116429550 extends (0, $c0oXD$Component) {
    constructor(props){
        super(props);
        this.UUID = $fe5bf96defe66407$var$getUniqueIdentifier();
    }
}
const $fe5bf96defe66407$var$UUIDContext = (0, $c0oXD$createContext)(null);
function $fe5bf96defe66407$var$useBasicUUID() {
    const ref = (0, $c0oXD$useRef)($fe5bf96defe66407$var$getUniqueIdentifier());
    return ref.current;
}
const $fe5bf96defe66407$export$b53193151b894db6 = function() {
    const uuid = (0, $c0oXD$useContext)($fe5bf96defe66407$var$UUIDContext);
    if (uuid == null) return $fe5bf96defe66407$var$useBasicUUID();
    return uuid;
};
function $fe5bf96defe66407$export$1d23684b3f3271ac({ children: children }) {
    const ref = (0, $c0oXD$useRef)($fe5bf96defe66407$var$getUniqueIdentifier());
    return $fe5bf96defe66407$var$h($fe5bf96defe66407$var$UUIDContext.Provider, {
        value: ref.current,
        children: children
    });
}
function $fe5bf96defe66407$export$5e9808bef3bd64be(props) {
    const { pixelHeight: height, width: width } = (0, $c0oXD$useContext)((0, $e658232a3eec400d$exports.ColumnLayoutContext));
    let { id: frameID, className: className } = props;
    if (frameID.startsWith("#")) frameID = frameID.slice(1);
    return $fe5bf96defe66407$var$h("rect", {
        id: frameID,
        x: 0,
        y: 0,
        width: width,
        height: height,
        className: className
    });
}
function $fe5bf96defe66407$export$686c342f9382ceb9(props) {
    let { id: frameID } = props;
    const { scale: scale, divisions: divisions, grainsizeScale: gs } = (0, $c0oXD$useContext)((0, $e658232a3eec400d$exports.ColumnLayoutContext));
    if (frameID.startsWith("#")) frameID = frameID.slice(1);
    if (divisions.length === 0) return null;
    const [bottomOfSection, topOfSection] = scale.domain();
    const topOf = function(d) {
        let { top: top } = d;
        if (top > topOfSection) top = topOfSection;
        return scale(top);
    };
    const bottomOf = function(d) {
        let { bottom: bottom } = d;
        if (bottom < bottomOfSection) bottom = bottomOfSection;
        return scale(bottom);
    };
    const filteredDivisions = divisions.filter(function(d) {
        if (d.top <= bottomOfSection) return false;
        if (d.bottom > topOfSection) return false;
        return true;
    });
    let _ = null;
    let currentGrainsize = "m";
    let div = null;
    for (div of Array.from(filteredDivisions)){
        if (_ == null) {
            _ = (0, $c0oXD$path)();
            _.moveTo(0, bottomOf(div));
        }
        if (div.grainsize != null) currentGrainsize = div.grainsize;
        const x = gs(currentGrainsize);
        _.lineTo(x, bottomOf(div));
        _.lineTo(x, topOf(div));
    }
    _.lineTo(0, topOf(div));
    _.closePath();
    return $fe5bf96defe66407$var$h("path", {
        id: frameID,
        key: frameID,
        d: _.toString()
    });
}
const $fe5bf96defe66407$export$407988c5e190497b = function(props) {
    let { id: id, children: children, ...rest } = props;
    if (id.startsWith("#")) id = id.slice(1);
    return (0, $c0oXD$createElement)("clipPath", {
        id: id,
        key: id,
        ...rest
    }, children);
};
const $fe5bf96defe66407$var$UseFrame = function(props) {
    const { id: frameID, ...rest } = props;
    return $fe5bf96defe66407$var$h("use.frame", {
        xlinkHref: frameID,
        fill: "transparent",
        key: "frame",
        ...rest
    });
};
const $fe5bf96defe66407$var$prefixID = function(uuid, prefixes) {
    const res = {};
    for (let prefix of Array.from(prefixes))res[prefix + "ID"] = `#${uuid}-${prefix}`;
    return res;
};
function $fe5bf96defe66407$export$708d3f2ecf132c6c(props) {
    const { left: left = 0, shiftY: shiftY = 0, className: className, onClick: onClick, children: children, frame: frame = $fe5bf96defe66407$export$5e9808bef3bd64be, clip: clip = true } = props;
    const uuid = $fe5bf96defe66407$export$b53193151b894db6();
    const { frameID: frameID, clipID: clipID } = $fe5bf96defe66407$var$prefixID(uuid, [
        "frame",
        "clip"
    ]);
    let transform = null;
    if (left != null) transform = `translate(${left} ${shiftY})`;
    const frameClassName = "frame";
    let _frame = $fe5bf96defe66407$var$h(frame, {
        id: frameID,
        className: frameClassName
    });
    let defs = null;
    let clipPath = null;
    if (clip) {
        defs = $fe5bf96defe66407$var$h("defs", {
            key: "defs"
        }, [
            _frame,
            $fe5bf96defe66407$var$h($fe5bf96defe66407$export$407988c5e190497b, {
                id: clipID
            }, $fe5bf96defe66407$var$h($fe5bf96defe66407$var$UseFrame, {
                id: frameID
            }))
        ]);
        clipPath = `url(${clipID})`;
        _frame = $fe5bf96defe66407$var$h($fe5bf96defe66407$var$UseFrame, {
            id: frameID,
            className: frameClassName
        });
    }
    return $fe5bf96defe66407$var$h("g", {
        className: className,
        transform: transform,
        onClick: onClick
    }, [
        defs,
        _frame,
        $fe5bf96defe66407$var$h("g.inner", {
            clipPath: clipPath
        }, children)
    ]);
}


//# sourceMappingURL=frame.bf41eea6.js.map
